import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { range } from './array';
import { strPadStart } from './string';
dayjs.extend(customParseFormat);
/**
 * Gets the list of hours in 12hr format
 *
 * @param {bool} disableFirstOption
 * @return {array}
 */
export var getHourOptions = function getHourOptions(disableFirstOption) {
  if (disableFirstOption === void 0) {
    disableFirstOption = false;
  }
  var options = range(1, 12).map(function (hour) {
    var formatted = strPadStart(hour, 2, '0');
    return {
      label: formatted,
      value: formatted
    };
  });
  return [{
    label: '',
    value: '',
    disabled: disableFirstOption
  }].concat(options);
};

/**
 * Gets the list of minutes
 *
 * @param {number} min
 * @param {number} max
 * @param {number} step
 * @param {bool} disableFirstOption
 * @return {array}
 */
export var getMinuteOptions = function getMinuteOptions(min, max, step, disableFirstOption) {
  if (disableFirstOption === void 0) {
    disableFirstOption = false;
  }
  var options = range(min, max, step).map(function (minute) {
    var formatted = strPadStart(minute, 2, '0');
    return {
      label: formatted,
      value: formatted
    };
  });
  return [{
    label: '',
    value: '',
    disabled: disableFirstOption
  }].concat(options);
};

/**
 * Gets the list of meridians
 *
 * @param {bool} disableFirstOption
 * @return {array}
 */
export var getMeridianOptions = function getMeridianOptions(disableFirstOption) {
  if (disableFirstOption === void 0) {
    disableFirstOption = false;
  }
  return [{
    label: '',
    value: '',
    disabled: disableFirstOption
  }, {
    label: 'AM',
    value: 'am'
  }, {
    label: 'PM',
    value: 'pm'
  }];
};

/**
 * Get a date object based on time string and provided time format.
 *
 * @param {string} timeStr
 * @param {string|array} format
 * @return {dayjs}
 */
export var parseTimeStrByFormat = function parseTimeStrByFormat(timeStr, format) {
  if (format === void 0) {
    format = 'HH:mm:ss';
  }
  return dayjs(timeStr, format);
};